<template>
  <div class="dict-manage">
    <el-card class="search-card">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="关键字">
          <el-input v-model="searchForm.keyword" placeholder="名称/编码/标签" clearable @keyup.enter.native="handleSearch"></el-input>
        </el-form-item>
        <el-form-item label="标签">
          <el-select v-model="searchForm.tag" placeholder="请选择" clearable filterable>
            <el-option v-for="tag in tagList" :key="tag" :label="tag" :value="tag"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch" :loading="searchLoading">查询</el-button>
          <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
          <el-button @click="handleAdd">新增</el-button>
          <el-button :disabled="selectedRows.length === 0" @click="handleBatchDelete" :loading="batchDeleteLoading">批量删除</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="table-card">
      <el-table :data="tableData" border stripe v-loading="loading" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="50" />
        <el-table-column type="index" label="序号" width="60" :index="indexMethod" />
        <el-table-column prop="tag" label="标签" width="180" />
        <el-table-column prop="code" label="编码" width="150" />
        <el-table-column prop="name" label="名称" width="150" />
        <el-table-column prop="parentCode" label="父级编码" width="120" />
        <el-table-column prop="sortIndex" label="排序" width="80" />
        <el-table-column prop="remark" label="备注" min-width="150" />
        <el-table-column prop="createTime" label="创建时间" width="160" />
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" style="color: #F56C6C;" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <div class="pagination-wrapper">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
      />
    </div>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false" @open="onDialogOpen">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="标签" prop="tag">
          <el-autocomplete
            v-model="form.tag"
            :fetch-suggestions="queryTags"
            placeholder="请输入或选择标签"
            style="width: 100%;"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item label="编码" prop="code">
          <el-input v-model="form.code" placeholder="请输入编码" clearable></el-input>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item label="父级编码">
          <el-input v-model="form.parentCode" placeholder="请输入父级编码（可选）" clearable></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sortIndex" :min="0" :max="9999"></el-input-number>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" :rows="2" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from '../services/api';

export default {
  name: 'DictManage',
  data() {
    return {
      searchForm: {
        keyword: '',
        tag: ''
      },
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      loading: false,
      searchLoading: false,
      deleteLoading: false,
      batchDeleteLoading: false,
      selectedRows: [],
      tagList: [],
      dialogVisible: false,
      dialogTitle: '新增字典',
      submitLoading: false,
      editingId: null,
      form: {
        tag: '',
        code: '',
        name: '',
        parentCode: '',
        sortIndex: 0,
        remark: ''
      },
      rules: {
        tag: [{ required: true, message: '请输入标签', trigger: ['blur', 'change'] }],
        code: [{ required: true, message: '请输入编码', trigger: ['blur', 'change'] }],
        name: [{ required: true, message: '请输入名称', trigger: ['blur', 'change'] }]
      }
    };
  },
  created() {
    this.loadData();
    this.loadTags();
  },
  methods: {
    async loadData() {
      this.loading = true;
      try {
        const res = await api.post('/dict/list', {
          keyword: this.searchForm.keyword,
          tag: this.searchForm.tag,
          page: this.currentPage,
          pageSize: this.pageSize
        });
        if (res.data.success) {
          this.tableData = res.data.data.list;
          this.total = res.data.data.total;
        }
      } catch (error) {
        this.$message.error('加载数据失败');
      } finally {
        this.loading = false;
      }
    },
    async loadTags() {
      try {
        const res = await api.post('/dict/tags', {});
        if (res.data.success) {
          this.tagList = res.data.data;
        }
      } catch (error) {
        console.error('加载标签失败', error);
      }
    },
    queryTags(queryString, cb) {
      const results = queryString
        ? this.tagList.filter(tag => tag.toLowerCase().includes(queryString.toLowerCase())).map(tag => ({ value: tag }))
        : this.tagList.map(tag => ({ value: tag }));
      cb(results);
    },
    async handleSearch() {
      this.searchLoading = true;
      this.currentPage = 1;
      await this.loadData();
      this.searchLoading = false;
    },
    resetSearch() {
      this.searchForm = { keyword: '', tag: '' };
      this.currentPage = 1;
      this.loadData();
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.loadData();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.loadData();
    },
    handleSelectionChange(rows) {
      this.selectedRows = rows;
    },
    indexMethod(index) {
      return (this.currentPage - 1) * this.pageSize + index + 1;
    },
    handleAdd() {
      this.dialogTitle = '新增字典';
      this.editingId = null;
      this.form = { tag: '', code: '', name: '', parentCode: '', sortIndex: 0, remark: '' };
      this.dialogVisible = true;
    },
    handleEdit(row) {
      this.dialogTitle = '编辑字典';
      this.editingId = row.id;
      this.form = {
        tag: row.tag,
        code: row.code,
        name: row.name,
        parentCode: row.parentCode || '',
        sortIndex: row.sortIndex || 0,
        remark: row.remark || ''
      };
      this.dialogVisible = true;
    },
    onDialogOpen() {
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },
    async handleSubmit() {
      try {
        await this.$refs.form.validate();
      } catch (e) {
        this.$nextTick(() => {
          const errorEl = document.querySelector('.el-form-item.is-error');
          if (errorEl) {
            errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
        return;
      }
      this.submitLoading = true;
      try {
        let res;
        if (this.editingId) {
          res = await api.post(`/dict/${this.editingId}/update`, this.form);
        } else {
          res = await api.post('/dict/add', this.form);
        }
        if (res.data.success) {
          this.$message.success(res.data.message || '操作成功');
          this.dialogVisible = false;
          this.loadData();
          this.loadTags();
        } else {
          this.$message.error(res.data.message || '操作失败');
        }
      } catch (error) {
        this.$message.error(error.response?.data?.message || '操作失败');
      } finally {
        this.submitLoading = false;
      }
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确定要删除该字典项吗？', '提示', { type: 'warning' });
        this.deleteLoading = true;
        const res = await api.post(`/dict/${row.id}/remove`);
        if (res.data.success) {
          this.$message.success('删除成功');
          this.loadData();
        } else {
          this.$message.error(res.data.message || '删除失败');
        }
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error('删除失败');
        }
      } finally {
        this.deleteLoading = false;
      }
    },
    async handleBatchDelete() {
      if (this.selectedRows.length === 0) return;
      try {
        await this.$confirm(`确定要删除选中的 ${this.selectedRows.length} 条记录吗？`, '提示', { type: 'warning' });
        this.batchDeleteLoading = true;
        for (const row of this.selectedRows) {
          await api.post(`/dict/${row.id}/remove`);
        }
        this.$message.success('批量删除成功');
        this.loadData();
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error('批量删除失败');
        }
      } finally {
        this.batchDeleteLoading = false;
      }
    }
  }
};
</script>

<style scoped>
.dict-manage {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding-bottom: 56px;
}

.search-card {
  margin-bottom: 12px;
}

.search-form {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}

.table-card {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.table-card >>> .el-card__body {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0;
  overflow: hidden;
}

.table-card >>> .el-table {
  flex: 1;
}
</style>
